import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { IrisButtonModule } from '@sondermind/iris/button';
import { IrisIconComponent } from '@sondermind/iris/icon';

import { CoverageNotificationBannerComponent } from './coverage-notification-banner.component';

/** Renders just the coverage banner, so a feature can use it without importing the full `AccountEditModule`. */
@NgModule({
  imports: [CommonModule, RouterModule, IrisButtonModule, IrisIconComponent],
  declarations: [CoverageNotificationBannerComponent],
  exports: [CoverageNotificationBannerComponent]
})
export class CoverageNotificationBannerModule {}
